import { render } from "./AgilesformationView.vue?vue&type=template&id=5bddb2e7&scoped=true"
import script from "./AgilesformationView.vue?vue&type=script&lang=js"
export * from "./AgilesformationView.vue?vue&type=script&lang=js"

import "./AgilesformationView.vue?vue&type=style&index=0&id=5bddb2e7&scoped=true&lang=css"

import exportComponent from "C:\\AT\\Sites\\agiles_website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bddb2e7"]])

export default __exports__